<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <!-- <v-col>
          <v-card>
            <v-card-title> Product </v-card-title>
          </v-card>
        </v-col> -->
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title class="pb-0">
              <v-btn outlined class="" color="primary">
                <download-csv :data="customers" name="customers data.csv" :fields="list">
                  Export Customers
                </download-csv>
              </v-btn>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                outlined
                dense
                append-icon="mdi-magnify"
                label="Search all Customers"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="customers"
              :search="search"
              :loading="loading3"
              loading-text="Fetching Customers please wait...."
            >
              <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.name"
                              label="Customer Name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.phone"
                              label="Telephone"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.dob"
                              label="Birhday"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.address"
                              label="Email"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="close">
                        Cancel
                      </v-btn>
                      <v-btn
                        color="primary"
                        text
                        @click="save()"
                        :loading="loading2"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Are you sure you want to delete this
                      product?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        text
                        @click="deleteItemConfirm(delItem)"
                        :loading="loading1"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  color="primary"
                  small
                  class="mr-2"
                  width="55"
                  @click="editItem(item)"
                  >Edit</v-btn
                >
                <v-btn
                  color="primary"
                  small
                  class=""
                  width="55"
                  @click="deleteItem(item)"
                  >Delete</v-btn
                >
              </template>
              <template v-slot:no-data>
                <span>No data available</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    loading1: false,
    loading3: false,
    loading2: false,
    dialogView: false,
    views: [],
    list:['name', 'phone', 'dob'],
    delItem: {},
    items: ["goods", "services"],

    dialogDelete: false,
    headers: [
      {
        text: "Customer Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Telephone", value: "phone", sortable: false },
      { text: "Birthday", value: "dob", sortable: false },

      { text: "Actions", value: "actions", sortable: false },
    ],
    customers: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      phone: "",
      dob: "",
      address: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Customer";
    },
    ...mapGetters(["getUser", "currentUser"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.fetchCustomers();
  },

  methods: {
    fetchCustomers() {
      this.loading3 = true;
      fetch(
        "https://receipt.drecsoft.com/api/v1/customer/fetch-customer?pagination=false",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.customers = response.data.customer.data;
          this.loading3 = false;
          console.log(response.data);
        })

        .catch((err) => {
          this.loading = false;
          this.loading3 = false;
          console.log(err);
        });
    },

    editItem(item) {
      this.editedIndex = this.customers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.delItem = item;
      this.editedIndex = this.customers.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialogDelete = true;
    },

    deleteItemConfirm(item) {
      this.loading1 = true;
      fetch(
        "https://receipt.drecsoft.com/api/v1/customer/updated-customer-status",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
          body: JSON.stringify({
            cid: item.cid,
            status: "deleted",
          }),
        }
      )
        .then((response) => {
          this.loading1 = false;
          this.customers.splice(this.editedIndex, 1);
          this.closeDelete();
          console.log("deleted successfuly", response);
        })

        .catch((err) => {
          this.loading1 = false;
          console.log(err);
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    view(item) {
      this.views = item;
      this.dialogView = true;
    },
    closeMore() {
      this.dialogView = false;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.customers[this.editedIndex], this.editedItem);
        console.log(this.editedItem.stock);
        (this.loading2 = true),
          fetch(
            "https://receipt.drecsoft.com/api/v1/customer/update-customer",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.currentUser}`,
              },
              body: JSON.stringify({
                cid: this.editedItem.cid,
                phone: this.editedItem.phone,
                dob: this.editedItem.dob,
                email: this.editedItem.address,
                name: this.editedItem.name,
              }),
            }
          )
            .then((res) => res.json())
            .then((response) => {
              this.loading2 = false;
              console.log("updated successfuly", response);
              this.close();
            })

            .catch((err) => {
              this.loading2 = false;
              console.log(err);
              this.close();
            });
      }
    },
  },
};
</script>

<style scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>
